export default __webpack_public_path__ + "static/media/carjoin3.4e812f67.png";